import { onUnmounted, watch } from 'vue';
import { useSidebarIsOpen } from './useSidebarIsOpen';
import { useChatStore } from '@/stores/useChatStore';
import { RIGHT_SIDEBAR } from '@/types/ui';

export function useResetChatOnSidebarClose() {
  const isRightSidebarOpen = useSidebarIsOpen(RIGHT_SIDEBAR);
  const chatStore = useChatStore();

  const stopWatcher = watch(isRightSidebarOpen, (isOpen) => {
    if (!isOpen) {
      chatStore.resetState();
    }
  });

  onUnmounted(() => {
    stopWatcher();
  });

  return {
    stopWatcher
  };
}
